import React from 'react';
import './SuccessRate.scss';
import HappyFaceIcon from 'Components/icons/HappyFaceIcon';
import StraightFaceIcon from 'Components/icons/StraightFaceIcon';
import LostFaceIcon from 'Components/icons/LostFaceIcon';

const SuccessRate = (percentage) => {
  let extraClass;
  let icon;
  let dummyValue;
  if (percentage.percentage) {
    if (percentage.percentage >= 67  && percentage.percentage <= 100) {
      extraClass = 'green';
      icon = <HappyFaceIcon />;
    } else if (percentage.percentage >= 34 && percentage.percentage <= 66) {
      extraClass = 'yellow';
      icon = <StraightFaceIcon />;
    } else if (percentage.percentage > 0 && percentage.percentage <= 33) {
      extraClass = 'red';
      icon = <LostFaceIcon />;
    } else { extraClass = 'black'; }
  } else {
    extraClass = 'red';
    dummyValue = 0;
    icon = <LostFaceIcon />;
  }
  return (
    <div className={`success__rate success__rate-${extraClass} ${percentage.percentage > 100 ? 'aligner' : ''}`}>
      <div>{icon}&nbsp;{percentage.percentage ? percentage.percentage > 100 ? '--' : `${percentage.percentage}%` : `${dummyValue}%`}</div>
    </div>
  );
};

export default SuccessRate;